import { getTimePeriodELT, formatDate, shortDisplayDate24HourWithSec } from "../../utils/displayTime";

export const customListRequestObject = timeFilter => {
  return { ...timeFilter };
};

const timePeriodArray = getTimePeriodELT('720');

export const appsFilter = {
  time_frame: "30d",
  entry_ts: {
    start: shortDisplayDate24HourWithSec(formatDate(timePeriodArray.current_period[0]).utc()),
    end: shortDisplayDate24HourWithSec(formatDate(timePeriodArray.current_period[1]).utc())
  },
  sort: {"application": "asc"},
  fields: ["application"]
};
